import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import PrintProductsGroup from '../PrintProductsGroup';
import PrintProductSizeSuccessModal from '../PrintProductsGroup/components/PrintProductSizeSuccessModal';

const propTypes = {
  standardPrintProducts: PropTypes.shape({
    records: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
    ),
  }).isRequired,
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onPrintProductItemToggle: PropTypes.func.isRequired,
  onCheckout: PropTypes.func.isRequired,
  renderItem: PropTypes.func,
  readOnly: PropTypes.bool,
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  identity: PropTypes.shape({
    id: PropTypes.string,
  }),
  getCartItem: PropTypes.func,
  watermarkSettings: PropTypes.shape({
    wallpaperCustomText: PropTypes.string,
    wallpaperFontSize: PropTypes.number,
  }),
};

const StandardPrintOption = ({
  standardPrintProducts,
  photo,
  onPrintProductItemToggle,
  onCheckout,
  renderItem,
  readOnly,
  albumMembershipGroup,
  identity,
  getCartItem,
  watermarkSettings,
}) => {
  const [configuredAccountCard, setConfiguredAccountCard] = useState(null);

  return (
    <Fragment>
      <PrintProductsGroup
        printProducts={standardPrintProducts.records}
        onCartItemToggle={({
          accountCard,
          albumCustomPrint,
          printProductSize,
        }) => {
          onPrintProductItemToggle({
            accountCard,
            albumCustomPrint,
            printProductSize,
          });

          setConfiguredAccountCard(accountCard);
        }}
        readOnly={readOnly}
        photo={photo}
        renderPrintProduct={renderItem}
        albumMembershipGroup={albumMembershipGroup}
        identity={identity}
        getCartItem={getCartItem}
        watermarkSettings={watermarkSettings}
      />

      {configuredAccountCard && (
        <PrintProductSizeSuccessModal
          forceOpen
          accountCard={configuredAccountCard}
          onCheckout={() => {
            setConfiguredAccountCard(null);
            onCheckout();
          }}
          onDismiss={() => {
            setConfiguredAccountCard(null);
          }}
        />
      )}
    </Fragment>
  );
};

StandardPrintOption.propTypes = propTypes;

export default StandardPrintOption;
